import DM from 'DM';
import WPJSLib from '../vendor/wpjslib.js';
import { showAds }  from '../utils/trackers-utils.js';

const entryWithAction = DM.EntryWithAction && DM.EntryWithAction.split('/');
const entrywithActionKey = entryWithAction && `${entryWithAction[0]}${entryWithAction[1].replace(/^\w/, c => c.toUpperCase())}`;

const wpjslib = new WPJSLib({
    entry: DM.Entry,
    hasAds: showAds && ['trends/details', 'products/index'].includes(DM.EntryWithAction)
});

const isMobile = window.innerWidth < 1280;

const onFirstInteraction = {
    home(trackers) {
        trackers.track('homeView');
    },
    productdetails(trackers) {
        const model = JSON.parse(DM.Boot.ProductDetails.json);

        if (model) {
            trackers.track('productDetailsView', {
                categoryName: (model.mainCategory && model.mainCategory.categoryName) || '',
                categoryId: model.mainCategory && model.mainCategory.categoryId,
                productName: model.productName,
                productId: model.productId,
                price: model.price,
            });
        } else {
            trackers.track('pageView', {
                entry: entrywithActionKey
            });
        }
    },
    products(trackers) {
        const model = DM.Boot.TrackingScripts;
        const qGraphModel = DM.Boot.QGraph;

        if (model && qGraphModel) {
            const qgraphTracking = {
                ...JSON.parse(DM.Boot.ProductListPage.qGraphJson),
                url: window.location.origin
            };

            trackers.track('productsView', {
                categoryName: model.categoryName,
                categoryId: model.categoryId,
                products: model.products,
                qgraphTracking,
            });
        } else {
            trackers.track('pageView', {
                entry: entrywithActionKey
            });
        }

        if (!isMobile) {
            wpjslib.loadSlots();
        }

    },
    trendsIndex(trackers) {
        const model = DM.Boot.TrackingScripts;
        if (model) {
            trackers.track('trendsView', {
                articles: model
            });
        } else {
            trackers.track('pageView', {
                entry: entrywithActionKey
            });
        }
    },
    trendsDetails(trackers) {
        const model = DM.Boot.TrackingScripts;

        if (model) {
            trackers.track('trendDetailsView', {
                products: model.products,
                title: model.trendTitle
            });
        } else {
            trackers.track('pageView', {
                entry: entrywithActionKey
            });
        }
        // wpjslib.registerDOMSlots();
        wpjslib.loadSlots();
    },
    profileLastclickedproducts(trackers) {
        const model = DM.Boot.TrackingScripts;

        if (model && model.length) {
            trackers.track('profileProductsView', {
                name: 'Ostatnio przeglądane',
                products: model
            });
        } else {
            trackers.track('pageView', {
                entry: entrywithActionKey
            });
        }
    },
    profileLikedproducts(trackers) {
        const model = DM.Boot.TrackingScripts;

        if (model && model.length) {
            trackers.track('profileProductsView', {
                name: 'Ulubione',
                products: model
            });
        } else {
            trackers.track('pageView', {
                entry: entrywithActionKey
            });
        }
    },
    landingpages(trackers) {
        trackers.track('landingPageView', {
            name: window.location.pathname.replace('/', ''),
        });
    },
    seoIndex(trackers) {
        const model = DM.Boot.TrackingScripts;

        if (model) {
            trackers.track('seoIndexView', {
                categoryName: model.categoryName,
                url: model.url
            });
        } else {
            trackers.track('pageView', {
                entry: entrywithActionKey
            });
        }
    },
    other(trackers) {
        trackers.track('pageView', {
            entry: entrywithActionKey
        });
    },
};

const onInit = {
    products() {
        if (isMobile) {
            wpjslib.loadSlots();
        }
    },
    trendsIndex() {
        wpjslib.loadSlots();
    },
    seoIndex() {
        wpjslib.loadSlots();
    },
    brandsIndex() {
        wpjslib.loadSlots();
    },
    profileLikedproducts() {
        wpjslib.loadSlots();
    },
    landingpages() {
        wpjslib.loadSlots();
    },
};

window.addEventListener('load', (event) => {
    if (onInit.hasOwnProperty(entrywithActionKey)) {
        onInit[entrywithActionKey]();
    } else {
        if (onInit.hasOwnProperty(DM.Entry)) {
            onInit[DM.Entry]();
        }
    }
});

window.addEventListener('firstInteraction', () => {
    import(/* webpackChunkName: "trackers" */ '@trackers').then((m) => {
        if (onFirstInteraction.hasOwnProperty(entrywithActionKey)) {
            onFirstInteraction[entrywithActionKey](m.default);
        } else {
            if (onFirstInteraction.hasOwnProperty(DM.Entry)) {
                onFirstInteraction[DM.Entry](m.default);
            } else {
                onFirstInteraction.other(m.default);
            }
        }
    });
});

window.addEventListener('productListPageRefresh', () => {
    wpjslib.refreshSlots();
});
